export default {
  "--color-neutral-0": "rgb(250, 248, 251)",
  "--color-neutral-10": "rgb(245, 242, 248)",
  "--color-neutral-20": "rgb(230, 222, 237)",
  "--color-neutral-30": "rgb(205, 189, 219)",
  "--color-neutral-40": "rgb(179, 156, 201)",
  "--color-neutral-50": "rgb(154, 122, 184)",
  "--color-neutral-60": "rgb(129, 89, 166)",
  "--color-neutral-70": "rgb(103, 71, 133)",
  "--color-neutral-80": "rgb(72, 50, 93)",
  "--color-neutral-85": "rgb(57, 39, 73)",
  "--color-neutral-90": "rgb(46, 32, 60)",
  "--color-neutral-95": "rgb(36, 25, 46)",
  "--color-neutral-100": "rgb(26, 18, 33)",
  "--color-primary": "rgb(14, 216, 182)",
  "--color-primary-active": "rgb(15, 230, 194)",
  "--color-primary-inverse": "rgb(2, 24, 20)",
  "--color-secondary": "rgb(118, 14, 216)",
  "--color-secondary-active": "rgb(136, 25, 240)",
  "--color-secondary-inverse": "rgb(248, 241, 254)",
  "--color-success": "rgb(81, 193, 11)",
  "--color-success-active": "rgb(91, 217, 13)",
  "--color-success-inverse": "rgb(246, 254, 241)",
  "--color-danger": "rgb(223, 32, 64)",
  "--color-danger-active": "rgb(227, 59, 87)",
  "--color-danger-inverse": "rgb(253, 242, 244)",
  "--color-warning": "rgb(237, 120, 18)",
  "--color-warning-active": "rgb(239, 136, 46)",
  "--color-warning-inverse": "rgb(254, 247, 241)",
  "--color-yellow": "rgb(245, 196, 0)",
  "--color-yellow-active": "rgb(255, 206, 10)",
  "--color-yellow-inverse": "rgb(255, 252, 240)",
  "--text-color-base": "rgb(230, 222, 237)",
  "--text-color-soft": "rgb(179, 156, 201)",
  "--text-color-softer": "rgb(129, 89, 166)",
  "--text-color-disabled": "rgb(129, 89, 166)",
  "--text-color-inverse": "rgb(36, 25, 46)",
  "--text-color-link": "rgb(14, 216, 182)",
  "--text-color-link-active": "rgb(15, 230, 194)",
  "--text-color-primary": "rgb(14, 216, 182)",
  "--text-color-primary-inverse": "rgb(2, 24, 20)",
  "--text-color-secondary": "rgb(118, 14, 216)",
  "--text-color-secondary-inverse": "rgb(248, 241, 254)",
  "--text-color-success": "rgb(81, 193, 11)",
  "--text-color-success-inverse": "rgb(246, 254, 241)",
  "--text-color-warning": "rgb(237, 120, 18)",
  "--text-color-warning-inverse": "rgb(254, 247, 241)",
  "--text-color-danger": "rgb(223, 32, 64)",
  "--text-color-danger-inverse": "rgb(253, 242, 244)",
  "--background-color-base": "rgb(26, 18, 33)",
  "--background-color-soft": "rgb(36, 25, 46)",
  "--background-color-softer": "rgb(46, 32, 60)",
  "--background-color-softer-active": "rgb(36, 25, 46)",
  "--background-color-softest": "rgb(57, 39, 73)",
  "--background-color-softest-active": "rgb(46, 32, 60)",
  "--background-color-inverse": "rgb(250, 248, 251)",
  "--background-color-inverse-soft": "rgb(245, 242, 248)",
  "--background-color-inverse-softer": "rgb(230, 222, 237)",
  "--background-color-inverse-softer-active": "rgb(205, 189, 219)",
  "--background-color-primary": "rgb(14, 216, 182)",
  "--background-color-primary-active": "rgb(15, 230, 194)",
  "--background-color-primary-inverse": "rgb(2, 24, 20)",
  "--background-color-secondary": "rgb(118, 14, 216)",
  "--background-color-secondary-active": "rgb(136, 25, 240)",
  "--background-color-secondary-inverse": "rgb(248, 241, 254)",
  "--background-color-success": "rgb(81, 193, 11)",
  "--background-color-success-active": "rgb(91, 217, 13)",
  "--background-color-success-inverse": "rgb(246, 254, 241)",
  "--background-color-warning": "rgb(237, 120, 18)",
  "--background-color-warning-active": "rgb(239, 136, 46)",
  "--background-color-warning-inverse": "rgb(254, 247, 241)",
  "--background-color-danger": "rgb(223, 32, 64)",
  "--background-color-danger-active": "rgb(227, 59, 87)",
  "--background-color-danger-inverse": "rgb(253, 242, 244)",
  "--border-color-base": "rgb(129, 89, 166)",
  "--border-color-soft": "rgb(103, 71, 133)",
  "--border-color-softer": "rgb(72, 50, 93)",
  "--border-color-active": "rgb(14, 216, 182)",
  "--border-color-primary": "rgb(14, 216, 182)",
  "--border-color-success": "rgb(81, 193, 11)",
  "--border-color-warning": "rgb(237, 120, 18)",
  "--border-color-danger": "rgb(223, 32, 64)",
  "--border-size-base": "2px",
  "--border-size-large": "3px",
  "--border-size-x-large": "6px",
  "--border-radius-base": "6px",
  "--border-radius-rounded": "2em",
  "--border-radius-circle": "50%",
  "--font-size-xxxx-large": "3.5rem",
  "--font-size-xxx-large": "3rem",
  "--font-size-xx-large": "2rem",
  "--font-size-x-large": "1.5rem",
  "--font-size-large": "1.25rem",
  "--font-size-base": "1rem",
  "--font-size-body": "16px",
  "--font-size-small": "0.8rem",
  "--font-size-x-small": "0.7rem",
  "--font-size-xx-small": "0.6rem",
  "--font-family-heading": "'Ubuntu', sans-serif",
  "--font-family-text": "'OpenSans', sans-serif",
  "--font-family-code": "inconsolata, monospace",
  "--font-weight-regular": "normal",
  "--font-weight-bold": "600",
  "--line-height-base": "1.6",
  "--line-height-small": "1.3",
  "--line-height-smaller": "1.1",
  "--box-shadow-large": "0 20px 60px 0 rgba(0, 0, 0, .8)",
  "--box-shadow-base": "0px 12px 26px -4px rgba(0, 0, 0, .8)",
  "--box-shadow-small": "0px 8px 18px -2px rgba(0, 0, 0, .8)",
  "--box-shadow-x-small": "0px 0px 3px 0px rgba(0, 0, 0, .8)",
  "--box-shadow-active": "0 0 6px 1px rgba(20, 100, 160, 0.5)",
  "--box-shadow-inset": "inset 0 0 20px 1px rgba(0,0,0,.15)",
  "--box-shadow-small-inset": "inset 0 0 0 1px rgba(0,0,0,.15)"
}